import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LanguageEnum } from '@project-types/LanguageEnum';
import { AppModeEnum } from '@project-types/AppModeEnum';



interface GlobalState {
	language: LanguageEnum,
	appMode: AppModeEnum,
};

const initialState: GlobalState = {
	language: process.env.LANGUAGE,
	appMode: AppModeEnum.initDataStart,
};



export const globalSlice = createSlice({
	name: 'global',
	initialState,
	reducers: {
		setLanguage: (state, action: PayloadAction<LanguageEnum>) => {
			state.language = action.payload;
		},
		setAppMode: (state, action: PayloadAction<AppModeEnum>) => {
			let mode = action.payload;
			state.appMode = mode === AppModeEnum.initDataSuccess
				? AppModeEnum.appSuccess
				: mode;
		},
	},
});



export const { setLanguage, setAppMode } = globalSlice.actions;